export default "__VITE_ASSET__Cxuk3VpU__"